import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  gameHistoryList: [],
  totalGameHistory: 0,
  singleGameHistory: null,
  loading: false,
  claimHistoryList: [],
  totalClaimHistory: 0,
  gameLeaderboardList: [],
  totalLeaderboard: 0,
  energyHistoryList: [],
  totalEnergyHistory: 0,
  loadingCoins: false,
  coinsList: [],
  exportLoading: false,
  btncHistoryList: [],
  totalBtncHistory: 0,
  userTasksList: [],
  totalUserTasks: 0,
  LeaderboardTransactionList: [],
  totalLeaderboardTransaction: 0,

  autoRefill: null,
  autoRefillLoading: false,
};

const slice = createSlice({
  name: "game",
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.rewardLeaderboardTransaction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      Act.rewardLeaderboardTransaction.fulfilled,
      (state, action) => {
        state.LeaderboardTransactionList = action.payload.data;
        state.totalLeaderboardTransaction = action.payload.totalcount;
        state.loading = false;
      },
    );
    builder.addCase(Act.rewardLeaderboardTransaction.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(Act.gameHistoryListApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.gameHistoryListApi.fulfilled, (state, action) => {
      state.gameHistoryList = action.payload.data;
      state.totalGameHistory = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.gameHistoryListApi.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.gameHistoryDetailsApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.gameHistoryDetailsApi.fulfilled, (state, action) => {
      state.singleGameHistory = action.payload.data;
      state.loading = false;
    });
    builder.addCase(Act.gameHistoryDetailsApi.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.gameLeaderboardListApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.gameLeaderboardListApi.fulfilled, (state, action) => {
      state.gameLeaderboardList = action.payload.data;
      state.totalLeaderboard = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.gameLeaderboardListApi.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.ClaimHistoryListApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.ClaimHistoryListApi.fulfilled, (state, action) => {
      state.claimHistoryList = action.payload.data;
      state.totalClaimHistory = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.ClaimHistoryListApi.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.EnergyHistoryListApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.EnergyHistoryListApi.fulfilled, (state, action) => {
      state.energyHistoryList = action.payload.data;
      state.totalEnergyHistory = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.EnergyHistoryListApi.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.getCoinsListApi.pending, (state, action) => {
      state.loadingCoins = true;
    });
    builder.addCase(Act.getCoinsListApi.fulfilled, (state, action) => {
      state.coinsList = action.payload.data;
      state.loadingCoins = false;
    });
    builder.addCase(Act.getCoinsListApi.rejected, (state, action) => {
      state.loadingCoins = false;
    });

    builder.addCase(Act.getAutoRefillCoinTime.pending, (state, action) => {
      state.autoRefillLoading = true;
    });
    builder.addCase(Act.getAutoRefillCoinTime.fulfilled, (state, action) => {
      state.autoRefill = action.payload.data;
      state.autoRefillLoading = false;
    });
    builder.addCase(Act.getAutoRefillCoinTime.rejected, (state, action) => {
      state.autoRefillLoading = false;
    });

    builder.addCase(Act.exportGameList.pending, (state, action) => {
      state.exportLoading = true;
    });
    builder.addCase(Act.exportGameList.fulfilled, (state, action) => {
      state.exportLoading = false;
    });
    builder.addCase(Act.exportGameList.rejected, (state, action) => {
      state.exportLoading = false;
    });

    builder.addCase(Act.exportClaimList.pending, (state, action) => {
      state.exportLoading = true;
    });
    builder.addCase(Act.exportClaimList.fulfilled, (state, action) => {
      state.exportLoading = false;
    });
    builder.addCase(Act.exportClaimList.rejected, (state, action) => {
      state.exportLoading = false;
    });
    builder.addCase(Act.BtncHistoryListApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.BtncHistoryListApi.fulfilled, (state, action) => {
      state.btncHistoryList = action.payload.data;
      state.totalBtncHistory = action.payload.totalcount;
      state.loading = false;
    });
    builder.addCase(Act.BtncHistoryListApi.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.getUserTasks.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getUserTasks.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      userTasksList: payload.data,
      totalUserTasks: payload.totalcount,
    }));
    builder.addCase(Act.getUserTasks.rejected, (state, action) => ({
      ...state,
      loading: false,
      userTasksList: [],
      totalUserTasks: 0,
    }));
  },
});

export default slice;
